import { z } from "zod";
/** Uniform API envelope (api-z1 spirit) — plan/07-api-design.md */
export const errorDataSchema = z.object({
    msg: z.string(),
    code: z.string(),
});
export const successEnvelopeSchema = (data) => z.object({
    success: z.literal(true),
    data,
});
export const failureEnvelopeSchema = z.object({
    success: z.literal(false),
    data: errorDataSchema,
});
export function ok(data) {
    return { success: true, data };
}
export function fail(code, msg) {
    return { success: false, data: { code, msg } };
}
